import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Hash } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import {
	CleanIcon,
	ViewIcon,
	TrashIcon,
	FacebookSquareIcon,
	InstagramSquareIcon,
	WhatsappSquareIcon,
	ApiSquareIcon,
	TiktokSquareIcon
} from 'assets/icons';
import { ReportService } from 'services';
import moment from 'moment';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: ''
}

const HEADER = [
	'Fecha',
	'Cliente',
	'Teléfono',
	'Documento de Identidad',
	'Nº de Referencia',
	'Vía',
	'Total',
	'Acciones'
];

class SalesReport extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: this.props.user?.level_id != Constants.LEVELS.CLIENT ? [
			'Usuario',
			...HEADER
		] : HEADER,
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Ventas',
				onBack: null
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await ReportService.admin.sales.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.sales?.rows || [],
			last_page: res.sales?.count || 0,
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la venta?',async () => {
			await ReportService.admin.sales.delete({
				sale_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado la venta correctamente");
			this.load(true);
		});
	}

	view = async (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load());
	}

	getIcon = (item: any) => {
		if (item?.facebook_id) {
			return FacebookSquareIcon;
		}
		else if (item?.phone) {
			return WhatsappSquareIcon;
		}
		else if (item?.instagram_id) {
			return InstagramSquareIcon;
		}
		else if (item?.tiktok_id) {
			return TiktokSquareIcon;
		}
		else {
			return ApiSquareIcon;
		}
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="verifications-report">
				<Modal
		          className="modal-view-sale"
		          visible={ visible }
		          title="Venta"
		          onClose={ () => this.onClose() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalView
		          	item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-11 row">
								<div className="col-md-3">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por cliente"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md-3">
									<DatePicker
										label="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md-3">
									<DatePicker
										label="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md-1">
									{
										this.state.form != INITIAL_STATE && (
											<button className="btn btn-clean" onClick={ () => this.reset() }>
												<img src={ CleanIcon } />
											</button>
										)
									}
								</div>
							</div>
						</div>
					</div>
				</div>

				<Table title="Reporte de Ventas" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								{
									this.props.user?.level_id != Constants.LEVELS.CLIENT && (
										<td>{ i.user != null ? (i.user?.name + ' ' + i.user?.lastname) : '-' }</td>
									)
								}
								<td>{ moment(i?.created_at).format('DD/MM/YYYY HH:mm') }</td>
								<td>{ i.name || '-' }</td>
								<td>{ i.phone || '-' }</td>
								<td>{ i.document || '-' }</td>
								<td>{ i.reference || '-' }</td>
								<td>
									<img src={ this.getIcon(i?.session) } className="session-icon" />
								</td>
								<td>{ Globals.formatMiles(i.total,true,i.currency) }</td>
								<td>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Eliminar">
										<a className="link-icon link-red" href="#" onClick={ (e: any) => this.delete(e,i) }>
											<img src={ TrashIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(SalesReport);